import { DiagnosisItem } from "../../diagnosis.model";
import { Tooth } from "../../../../odontogram/odontogram.model";
import { ItemValidators } from "../../../item-validators";
import { AbstractCondition } from "../condition";

export class Splint extends AbstractCondition {
  static validate(
    item: DiagnosisItem,
    odontogram: Tooth[],
    items: DiagnosisItem[],
  ): boolean {
    // validate teeth selected
    if (!ItemValidators.hasTeethSelected(item, 2)) {
      return false;
    }

    // validate not missing
    if (!ItemValidators.notMissingTeeth(item, odontogram)) {
      // TODO: display error
      return false;
    }

    // validate same jaw
    if (!ItemValidators.sameJaw(item)) {
      // TODO: display error
      return false;
    }

    // validate splint option
    if (!ItemValidators.hasStatusSelected(item)) {
      return false;
    }

    return true;
  }

  static apply(odontogram: Tooth[], item: DiagnosisItem): Tooth[] {
    const mesialTeeth = [];
    const distalTeeth = [];

    let upperArch = Array.apply(null, Array(16));
    upperArch = upperArch.map((val, i) => {
      const number = i < 8 ? 18 - i : i + 13;
      return {
        number: number,
        applied: item.teeth.includes(number),
      };
    });

    let lowerArch = Array.apply(null, Array(16));
    lowerArch = lowerArch.map((val, i) => {
      const number = i < 8 ? 48 - i : i + 23;
      return {
        number: number,
        applied: item.teeth.includes(number),
      };
    });

    upperArch.forEach((tooth, i) => {
      if (tooth.applied) {
        if (i > 0 && upperArch[i - 1].applied) {
          if (i <= 7) {
            distalTeeth.push(tooth.number);
          } else {
            mesialTeeth.push(tooth.number);
          }
        }
        if (i < 15 && upperArch[i + 1].applied) {
          if (i <= 7) {
            mesialTeeth.push(tooth.number);
          } else {
            distalTeeth.push(tooth.number);
          }
        }
      }
    });

    lowerArch.forEach((tooth, i) => {
      if (tooth.applied) {
        if (i > 0 && lowerArch[i - 1].applied) {
          if (i <= 7) {
            distalTeeth.push(tooth.number);
          } else {
            mesialTeeth.push(tooth.number);
          }
        }
        if (i < 15 && lowerArch[i + 1].applied) {
          if (i <= 7) {
            mesialTeeth.push(tooth.number);
          } else {
            distalTeeth.push(tooth.number);
          }
        }
      }
    });

    odontogram
      .filter((tooth) => item.teeth.indexOf(tooth.number) > -1)
      .forEach((tooth, i) => {
        if (mesialTeeth.includes(tooth.number)) {
          tooth.diagnosis.push({
            condition: item.condition,
            options: `mesial ${item.options.status}`,
          });
        }
        if (distalTeeth.includes(tooth.number)) {
          tooth.diagnosis.push({
            condition: item.condition,
            options: `distal ${item.options.status}`,
          });
        }
      });

    return odontogram;
  }

  static getDescriptionIdentifiers(item: DiagnosisItem): string[] {
    return [`splint_${item.options.status === "ok" ? "ok" : "nok"}`];
  }

  static supports(condition: string): boolean {
    return condition === "splint";
  }

  static getItemResume(item: DiagnosisItem): any {
    return [
      {
        name: "status",
        value: item.options.status
          ? ["diagnosis.options.status." + item.options.status]
          : [],
      },
    ];
  }

  static getTableData(item: DiagnosisItem): any {
    return [
      "",
      item.options.status
        ? ["diagnosis.options.status." + item.options.status]
        : [],
    ];
  }
}



// WEBPACK FOOTER //
// /app/src/app/core/store/plan-editor/diagnosis/conditions/restorative/splint.ts